import React from 'react'
import { changeFieldInQueryBlock, handleFieldChange, handleFieldDateChange, removeInputField, returnFormType, sortFunc } from './AttributeSelectVM';
import { Button, FormControl, Input, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography } from '@mui/material';
import DataListAutoComplete from '../data-list-autocomplete/DataListAutoComplete';
import CloseIcon from '@mui/icons-material/Close';

const AttributeQueryBlock = ({field,formFields,fieldDropdown,callback,currentLayerId,view}) => {

    let type = returnFormType(field.type);
    const {fieldName,fieldLabel,}=field
    let options=[]
    if(field?.types?.length){
      type = 'select';
      const subTypes = field.types.map((item) => {
      
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          );
        });
        options=subTypes
  }
  if(field.domains.length){
    type='select'
    let list =[]
    let dict ={}
    field.domains.forEach((domain)=>{
      domain.codedValues.forEach((codedValue)=>{
        if(dict[codedValue.code] !== codedValue.code){
          list.push(codedValue)
        }
        dict[codedValue.code]=codedValue.code
        
      })
    })
    list.sort((a,b)=>sortFunc(a,b))
      let menuItems = list.map((codedValue) => {
        return (
          <MenuItem key={codedValue.name} value={codedValue.code}>
            {codedValue.name}
          </MenuItem>
        );
      });
    options = menuItems
  }
      return (
      <div key={`paper-queryBlock-${fieldName}`}>
      <Paper sx={{position:'relative',my:2,p:2,overflow:'auto'}}>
      <Stack direction="row" spacing={2} alignItems={'start'} flexWrap={'wrap'}>
      {fieldName.length &&
      <>
      <Stack direction="column"  spacing={2} alignItems={'start'} flexWrap={'wrap'}  >
          <FormControl>
            
          <Select
                  value={fieldName}
                  onChange={(e)=>{
                    changeFieldInQueryBlock({event:e, fieldName:fieldName, formFields:formFields, callback:callback});
        
                  }}
                  >{fieldDropdown}</Select>
                  </FormControl>
                 
                  {/* ADD THIS - Operator dropdown */}
                  <FormControl variant="standard" sx={{ minWidth: 100 }}>
                    <InputLabel id={`${fieldName}-operator-label`}>
                      Operator
                    </InputLabel>

                    <Select
                      labelId={`${fieldName}-operator-label`}
                      value={formFields[fieldName]?.queryOperator || "is"}
                      onChange={(e) => {
                        callback((prev) => ({
                          ...prev,
                          [fieldName]: {
                            ...prev[fieldName],
                            queryOperator: e.target.value,
                          },
                        }));
                      }}
                    >
                      <MenuItem value="is">is</MenuItem>
                      <MenuItem value="is not">is not</MenuItem>
                    </Select>
                  </FormControl>
                  
                  {type === 'number'&&
                  <>
                  <FormControl variant="standard">
                  <Input
                  placeholder='input value'
                    type={type}
                    id={fieldName}
                    name={fieldName}
                    value={formFields[fieldName].queryValue} //.toString()}
                    onChange={(e) =>
                      handleFieldChange(e, formFields[fieldName], callback)
                    }
                  ></Input>
                  </FormControl>
                  </>}
                  {type==='text' &&
                  <>
                  <FormControl variant="standard">
                <TextField
                    variant="standard"
                    placeholder='input value'
                    type={type}
                    id={fieldName}
                    name={fieldName}
                    value={formFields[fieldName].queryValue} //.toString()}
                    onChange={(e) =>
                      handleFieldChange(e, formFields[fieldName], callback)
                            }
                     inputProps={{list:`dataList-${fieldName}`}}
                    >
                    </TextField>
                    <DataListAutoComplete
                        id={`dataList-${fieldName}`}
                        currentLayerId={currentLayerId}
                        fieldName={fieldName}
                        view={view}
                        queryValue={formFields[fieldName].queryValue}
                        />
                        </FormControl>
                    </>
                  }
                  {
                      type === 'date' &&
                      <>
                      <FormControl variant="standard">
                    <Typography variant='subtitle1'>from: </Typography>
                      <Input
                      fullWidth
                        type={type}
                        id={`${fieldName}-from`}
                        name={`${fieldName}`}
                        value={formFields[
                          fieldName
                        ].queryValue.begin.toString()}
                        onChange={(e) => {
                          handleFieldDateChange(
                            e,
                            true,
                            formFields[fieldName],
                            callback
                          );
                        }}
                      ></Input>
                      </FormControl>
                      <FormControl variant="standard">
                      <Typography variant='subtitle1'>to: </Typography>
                      <Input
                      fullWidth
                        type={type}
                        id={`${fieldName}-to`}
                        name={`${fieldName}`}
                        value={formFields[fieldName].queryValue.end.toString()}
                        onChange={(e) =>
                          handleFieldDateChange(
                            e,
                            false,
                            formFields[fieldName],
                            callback
                          )
                        }
                      ></Input>
                      </FormControl>
                      </>
      
                  }
                  {type ==='select' &&
                  <>
                  <FormControl variant="standard" sx={{m:1,minWidth:120}}>
                              <InputLabel  id={`${fieldName}-label`}>
                select value
              </InputLabel>
              <Select
              autoWidth
              labelId={`${fieldName}-label`}
                name={fieldName}
                value={formFields[fieldName].queryValue.toString()}
                onChange={(e) =>{
                  handleFieldChange(e, formFields[fieldName], callback)
                }
                }
              >
                {options.length && options}
              </Select>
              </FormControl>
                  </>
                  }
                  </Stack>
                  </>
      }
      <Button
      sx={{position:'absolute', top:0, right:0}}
      onClick={(e) => {
          e.preventDefault();
          removeInputField(fieldName,formFields,callback)
                      }}>
          <CloseIcon color='warning'/>
      </Button>
      </Stack>
      </Paper>
            </div>
    )

}

export default AttributeQueryBlock